import React from "react";
import { connect } from "react-redux";
import Z4 from "../components/Z4";
import StatsUtils from "../../../utils/stats";
import { getKpiSelected } from "../selectors";
import { selectUserRoleId } from "../../../redux/selectors/user";
import { roles } from "../../../configs/constants";

const mapStateToProps = state => {
  const stats = state.stats || {};
  const filtersData = stats.filters || [];
  const zones3 = state.stats.zones.z3 || [];
  const userRoleId = selectUserRoleId(state);
  const zones3WithoutSectorFilter = zones3.filter(filterId => filterId !== 3);
  return {
    filters: StatsUtils.zoneToFilters(userRoleId === roles.TERRAIN ? zones3WithoutSectorFilter : zones3),
    kpi: getKpiSelected(state),
    filtersData
  };
};

export default connect(mapStateToProps, {})(Z4);



// WEBPACK FOOTER //
// src/modules/stats/containers/Z3SideContainer.js